import { useEffect, useState } from 'react';
import { type AnyVideo, getCommentsCount, isPopClipVideo } from '../../functions';

export function useCommentsCount(videoId: string, video: AnyVideo) {
  const [commentsCount, setCommentsCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function loadCount() {
      try {
        const clipId = isPopClipVideo(video) ? (video.clipId ?? video.id) : video.id;
        const result = await getCommentsCount({ clip_id: clipId });
        if (!cancelled) setCommentsCount(result.commentsCount);
      } catch {
        // Non-critical
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    void loadCount();
    return () => {
      cancelled = true;
    };
  }, [videoId, video]);

  useEffect(() => {
    function handleMessage(event: MessageEvent) {
      if (event.data?.type === 'COMMENT_COUNT_UPDATED' && event.data?.videoId === videoId) {
        setCommentsCount(event.data.count ?? 0);
      }
      if (event.data?.type === 'COMMENT_ADDED' && event.data?.videoId === videoId) {
        setCommentsCount((prev) => prev + 1);
      }
    }

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [videoId]);

  return { commentsCount, loading };
}
